// pages/team.js — Team page.
//
// Owns the `data-page="team"` section. Cloud-only when not solo;
// renders team members, invites, role management, settings.
//
// As of Phase J6h-a, renderTeamPageInner lives in src/team-page.js
// (this page only owns the 5s-cache wrapper + mount lifecycle).
// renderTeamSettings is in src/team-settings.js (Phase J6h-b).
// renderTeamV2 + renderTeamSwitcher still live in legacy until
// the auth/Supabase hoist lands (Phase J7) — they read supabase
// session state.
import { state } from "../state.js";
import { teamState } from "../page-state.js";
import { fetchTeamData } from "../fetchers.js";
import { renderTeamPageInner } from "../team-page.js";

export function renderTeamPage() {
  if (teamState.editing) return; // don't clobber active edit
  if (Date.now() - teamState.lastFetch > 5000) {
    fetchTeamData().then(renderTeamPageInner);
  } else {
    renderTeamPageInner();
  }
}

// ---- mount ----

let started = false;
let tickHandler = null;

function start() {
  if (started) return;
  started = true;
  // Initial render — cloud mode has no daemon-driven tick loop, so
  // without this the page sits blank until manual nav. See
  // policy.js / worktrees.js for the same fix.
  renderTeamPage();
  tickHandler = () => {
    if (state.activePage === "team") renderTeamPage();
  };
  document.addEventListener("dashboard:tick", tickHandler);
}

function stop() {
  if (!started) return;
  started = false;
  if (tickHandler) {
    document.removeEventListener("dashboard:tick", tickHandler);
    tickHandler = null;
  }
}

function bindLifecycle() {
  const section = document.querySelector('section.page[data-page="team"]');
  if (!section) return;
  if (section.classList.contains("active")) start();
  const obs = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.attributeName !== "class") return;
      if (section.classList.contains("active")) start();
      else stop();
    });
  });
  obs.observe(section, { attributes: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindLifecycle);
} else {
  bindLifecycle();
}
